import React from 'react';
import WaitlistSection from './sections/WaitlistSection';
import IdentityListPage from './sections/IdentityListPage';
import IdentityDetailPage from './sections/IdentityDetailPage';
import AdminListPage from './sections/AdminListPage';
import OrganizationListPage from './sections/OrganizationListPage';

export interface AdminSection {
  id: string;
  labelKey: string;
  icon: string;
  listElement: React.ReactNode;
  detailPath?: string;
  detailElement?: React.ReactNode;
  /**
   * When true the section's route is still registered (reachable by direct
   * URL) but no item is rendered for it in the admin sidebar nav.
   */
  hideFromNav?: boolean;
}

export const ADMIN_SECTIONS: AdminSection[] = [
  {
    id: 'waitlist',
    labelKey: 'admin.waitlist.title',
    icon: 'pi pi-inbox',
    listElement: <WaitlistSection />,
  },
  {
    id: 'identities',
    labelKey: 'admin.identities.title',
    icon: 'pi pi-users',
    listElement: <IdentityListPage />,
    detailPath: ':identityId',
    detailElement: <IdentityDetailPage />,
  },
  {
    id: 'admins',
    labelKey: 'admin.admins.title',
    icon: 'pi pi-shield',
    listElement: <AdminListPage />,
  },
  {
    id: 'organizations',
    labelKey: 'admin.organizations.title',
    icon: 'pi pi-building',
    listElement: <OrganizationListPage />,
  },
];

/**
 * Sections shown in the admin sidebar nav — the full registry minus any
 * entry flagged `hideFromNav`. Routes are still wired from ADMIN_SECTIONS.
 */
export const ADMIN_NAV_SECTIONS: AdminSection[] = ADMIN_SECTIONS.filter(
  (section) => !section.hideFromNav
);

/**
 * Default landing section for `/admin/metasphere` — the first nav-visible
 * section. Falls back to the first registry entry if every section is hidden.
 */
export const DEFAULT_ADMIN_SECTION_ID: string = (
  ADMIN_NAV_SECTIONS[0] ?? ADMIN_SECTIONS[0]
).id;
